module.exports = {
	'customFolder.m4.m410300': {
		'childrenSNames': 'Name of child',
		'childrenSAge': 'Age',
		'totalAppliedParentalLeaveServiceYears': 'Total Parental Leave Seniority',
		'applyByDate': 'Less than 30 days',
		'lessThanMonths': 'Less than 6 months',
		'moreThanMonths': 'More than 6 months',
		'parentalLeaveTenure': 'Parental leave seniority',
		'leaveWithoutPayHasApplied': '<%=name%> is currently associated with a leave without pay and cannot be deleted.',
		'leaveWithoutPayHasApplied2': '<%=name%> is currently associated with a leave without pay and cannot be modified.',
	},
	'customFolder.m3.m310600': {
		'childrenYearsOld': 'Age',
	},
	'customFolder.service.m3.service-m310600': {
		'detailedListOfEmployeeEligibilityFor': 'Subordinate Parental Leave',
	},
};
